import { db } from '../firebase';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where, orderBy } from 'firebase/firestore';

const commentsCollection = collection(db, 'comments');

// Create a new comment
export const createComment = async (commentData) => {
  try {
    const docRef = await addDoc(commentsCollection, {
      ...commentData,
      createdAt: new Date()
    });
    return docRef.id;
  } catch (error) {
    throw error;
  }
};

// Get comments by blogId
export const getCommentsByBlogId = async (blogId) => {
  try {
    const q = query(commentsCollection, where('blogId', '==', blogId), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};

// Get approved comments by blogId
export const getApprovedCommentsByBlogId = async (blogId) => {
  try {
    const q = query(commentsCollection, where('blogId', '==', blogId), where('status', '==', 'approved'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};

// Get all comments (for admin)
export const getAllComments = async () => {
  try {
    const q = query(commentsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};

// Update a comment
export const updateComment = async (id, updateData) => {
  try {
    const commentRef = doc(db, 'comments', id);
    await updateDoc(commentRef, updateData);
  } catch (error) {
    throw error;
  }
};

// Delete a comment
export const deleteComment = async (id) => {
  try {
    const commentRef = doc(db, 'comments', id);
    await deleteDoc(commentRef);
  } catch (error) {
    throw error;
  }
};